
export const keepDigits = (number, digital = 2) => {
	let res = number.toString();
	const zeroNum = digital - res.length;
	for (let i = 0; i < zeroNum; i++) {
		res = `0${res}`;
	}
	return res;
}

function getCountdownText(time) {
	const sUnit = 1;
	const mUnit = sUnit * 60;
	const hUnit = mUnit * 60;
	const hBar = keepDigits(Math.floor(time / hUnit));
	const mBar = keepDigits(Math.floor((time % hUnit) / mUnit));
	const sBar = keepDigits(Math.floor((time % mUnit) / sUnit));
	return `${hBar}:${mBar}:${sBar}`;
}
export class Countdown {
	initTime = 0;
	time = 0;
	currentTime = 0;
	timeInstance = null;
	text = "00:00:00";
	callback = () => { };
	constructor(_time, _callback) {
		this.initTime = _time;
		this.time = this.initTime;
		this.callback = _callback;
	}
	start() {
		if (!!this.currentTime) {
			this.time = this.currentTime;
		}
		this.text = getCountdownText(this.time);
		this.callback(this.text, this.time);
		this.timeInstance = setInterval(() => {
			if (this.time > 0) {
				this.time--;
				this.text = getCountdownText(this.time);
			} else {
				this.text = "00:00:00";
			}
			this.callback(this.text, this.time);
		}, 1000);
	}
	restart() {
		this.clear();
		this.time = this.initTime;
		this.start();
	}
	pause() {
		clearInterval(this.timeInstance);
		this.timeInstance = null;
		this.currentTime = this.time;
		this.text = getCountdownText(this.time);
	}
	clear() {
		clearInterval(this.timeInstance);
		this.timeInstance = null;
		this.currentTime = 0;
	}
	setTime(_time) {
		this.time = _time;
		this.restart();
	}
}